import { render, staticRenderFns } from "./manualReissue.vue?vue&type=template&id=60c79a08&scoped=true&"
import script from "./manualReissue.vue?vue&type=script&lang=js&"
export * from "./manualReissue.vue?vue&type=script&lang=js&"
import style0 from "./manualReissue.vue?vue&type=style&index=0&id=60c79a08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c79a08",
  null
  
)

export default component.exports